<form [formGroup]="interpolationForm">
    <label>Temperature Interpolation:</label>
    <div class="flex flex-col">
        <label for="interpolationDepth">Depth</label>
        <div class="flex w-full flex-nowrap items-end gap-2">
            <div class="min-w-0 flex-[1.7_1_0]">
                <app-validated-number-input [control]="interpolationDepthControl"
                    [value]="interpolationDepthControl.value ?? 0" [validation]="interpolationDepthValidation()"
                    id="interpolationDepth" [unit]="depthUnit" />
            </div>

            <div class="flex flex-shrink-0 items-end gap-1 whitespace-nowrap">
                <p-select class="w-[55px]" id="depthTypeSelected" [options]="depthTypes" optionLabel="name" optionValue="value" appendTo="body"
                    formControlName="interpolationDepthType" />

                <div class="flex min-w-[80px] items-center rounded-sm border border-surface-600 px-2 text-sm">
                    <span>{{ interpolatedTemp() | number:'1.2-2' }} {{ tempUnit }}</span>
                </div>

                <p-button size="small" outlined="true" severity="success" icon="pi pi-copy" title="Copy"
                    (onClick)="copyTemperature()" />
            </div>
        </div>

        @if (validationErrors().length > 0) {
            <div class="flex flex-col gap-2 mt-2">
                @for (error of validationErrors(); track $index) {
                    <p-message severity="error" [text]="error" styleClass="w-full" />
                }
            </div>
        }
    </div>
</form>
